import * as React from "../_snowpack/pkg/react.js";
import {DurationCtx} from "./store.js";
import {shallowEqual} from "../_snowpack/pkg/shallow-equal-object.js";
import {Pill, SelectedPill} from "./Style.js";
import {formatDuration} from "./date-helpers.js";
export const Entry = ({value}) => {
  const state = React.useContext(DurationCtx);
  const chosen = shallowEqual(value, state.duration);
  const onClick = () => {
    state.setDuration(!chosen ? value : null);
  };
  const Component = chosen ? SelectedPill : Pill;
  return /* @__PURE__ */ React.createElement(Component, {
    onClick,
    role: "radio",
    "aria-checked": chosen
  }, formatDuration(value, {delimiter: "&nbsp;"}));
};
